<template>
    <div class="field is-horizontal">
	  <div class="field-label">
	    <label class="label">{{ dropdown.attribute.name }}</label>
	  </div>
	  <div class="field-body" :style="{'margin-left': margin}">
	    <b-field>
          <b-select placeholder="Select Code" size="is-small" v-model="model" expanded>
	        <!-- <b-select placeholder="Select Code" size="is-small" v-model="model" expanded :required="dropdown.attribute.tags.length > 0"> -->
	            <option :value="code" v-for="(code, key) in dropdown.list">{{ code.name }}</option>
	        </b-select>
	    </b-field>
	  </div>
    </div>
</template>
<script>
import { CodeService } from "@/services/code.service";
export default {
	props: ['index', 'dropdown', 'dropdowns', 'selectedCodes'],
    data: () => ({
    	model: null,
    }),
    computed: {
      margin() {
        return (this.dropdown.index * 15) + 'px';
      } 
    },
    watch: {
    	model(code) {
        let selectedCodes = this.selectedCodes;
        selectedCodes[this.index] = code;
        let dropdown = this.dropdowns[this.index];
        let dropdowns = this.dropdowns;
        dropdowns = dropdowns.filter(element => {
          if (element.parentCount == dropdown.parentCount) {
            return true;
          }else if(element.parentCount.toString().includes(dropdown.parentCount)) {
            return false;
          }
          return true;
        });
        this.$emit('update:dropdowns', dropdowns);
        if (code) {
       	  this.getPossibleDropdown(code, this.index, dropdown, dropdowns);
        }
    	},
      dropdowns() {
        this.model = this.selectedCodes[this.index];
      }
    },
    methods: {
      async getPossibleDropdown(code, key, dropdown, dropdowns) {
        // let index = dropdown.index + 1;
        // Does the selected code->id match(1) a record in model_has_attributes?
        let dropdownToBeGenerate = await CodeService.getCodeTag({code_id: code.id});
          if (dropdownToBeGenerate.length) {
            // YES Next drop-down driven by: model_has_attributes->attribute_id
            this.getCode(code, key, dropdown, dropdowns, dropdownToBeGenerate);
          }else{
            // NO Does the current drop-down attribute->id match a record in model_has_attributes?
            let dropdownToBeGenerate = await CodeService.getCodeTag({attribute_id: dropdowns[key].attribute.id});
            if (dropdownToBeGenerate.length) {
              // Next drop-down driven by: model_has_attributes->attribute_id
              this.getCode(code, key, dropdown, dropdowns, dropdownToBeGenerate);
            }
          }
      },
      getCode(code, key, dropdown, dropdowns, dropdownToBeGenerate) {
        let index = dropdown.index + 1;
        let countDropdown = 0;
        setInterval(() => { 
          if (countDropdown < dropdownToBeGenerate.length) {
            const count = dropdownToBeGenerate.length - countDropdown;
            let attribute_id = dropdownToBeGenerate[countDropdown].pivot.attribute_id ? dropdownToBeGenerate[countDropdown].pivot.attribute_id : 0;
            CodeService.getDropdownCodes({code_id: code.id, attribute_id: attribute_id}).then(response => {
              if (response && response[0] && response[0].length) {
                let parent = dropdowns.length;
                let selectedCodes = this.selectedCodes;
                selectedCodes.splice(key+1, 0, null);
                this.$emit('update:selectedCodes', selectedCodes);
                dropdowns.splice(key+1, 0, 
                  {
                    list: response[0], 
                    attribute: response[1], 
                    count: count, 
                    parent: parent, 
                    child:'child-' + key, 
                    index: index, 
                    parentCount: dropdown.parentCount + '-' + ('child-' + count) + '-' + key + ' ',
                  }
                );
                this.$emit('update:dropdowns', dropdowns);
                selectedCodes = selectedCodes.slice(0, dropdowns.length);
                this.$emit('update:selectedCodes', selectedCodes);
              }
            });
            countDropdown++;
          }
        }, 500);
      }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/Orders/create/partials/dropdown.vue